import React, { useEffect, useState } from "react";
import classes from "./FAQs.module.scss";
import Accordion from "../../UI/Accordion/Accordion";

const FAQs = ({ countryData }: { countryData: any }) => {
  const [accordionData, setAccordionData] = useState<any[]>([]);
  const faqsData = countryData?.faq ?? [];

  useEffect(() => {
    const tempAccordionData = faqsData?.faqPoints?.map((item: any) => ({
      title: item?.title,
      description: <div dangerouslySetInnerHTML={{ __html: item?.description }}></div>,
    }));
    setAccordionData(tempAccordionData ?? []);
  }, [countryData]);

  return (
    <section id="faqs" className={classes["faq-section"]}>
      <div className={classes["faq-container"]}>
        <h2 className={classes["faq-heading"]}>{faqsData?.title}</h2>
        <div className={classes["faq-subtext"]} dangerouslySetInnerHTML={{ __html: faqsData?.subTitle1 ?? "" }}></div>

        <Accordion items={accordionData ?? []} defaultOpenIndex={0} theme="base" />
      </div>
    </section>
  );
};

export default FAQs;
